// 规范：https://app.mockplus.cn/app/51V9L4rrS/specs/design/WM8vyO7C5N
// https://cdn-zmyd.iwordnet.com/gallery/tr4dz.png

// [light, dark]
const theme = [
  ['#ffffff', '#1d2124'], // 1
  ['#f4f7fa', '#323943'], // 2
  ['#43C494', '#2e8867'], // 3
  ['linear-gradient(90deg, #45dc94, #3cd39b 100%)', '#2e8867'], // 4
  // ['#45dc94', '#2e8867'], // 4
  ['#ffb74d', '#b27f35'], // 5
  ['linear-gradient(180deg, #ffdc84, #ffb74d)', '#b27f35'], // 6
  ['#fff3e2', '#323943'], // 7
  ['#f4f4f4', '#333333'], // 8
  ['#d9f3ea', '#82918c'], // 9
  ['#ffedd4', '#4c4843'], // 10
];

const font = [
  ['#333333', '#dddddd'], // 1
  ['#666666', '#999999'], // 2
  ['#999999', '#666666'], // 3
  ['#dddddd', '#333333'], // 4
  ['#ffffff', '#dddddd'], // 5
  ['#43c494', '#2e8867'], // 6
  ['#ffb74d', '#b27f35'], // 7
  ['#fa4751', '#a1383f'], // 8
  ['#dddddd', '#666666'], // 9
];

const border = [
  ['#f4f4f4', '#333333'], // 1
  ['#f4f7fa', '#323943'], // 2
];

const lightTheme = { theme: {}, font: {}, border: {} };
const darkTheme = { theme: {}, font: {}, border: {} };


theme.forEach((array, index) => {
  const num = ++index;
  lightTheme.theme[`hex${num}`] = array[0];
  darkTheme.theme[`hex${num}`] = array[1];
});

font.forEach((array, index) => {
  const num = ++index;
  lightTheme.font[`hex${num}`] = array[0];
  darkTheme.font[`hex${num}`] = array[1];
});

border.forEach((array, index) => {
  const num = ++index;
  lightTheme.border[`hex${num}`] = array[0];
  darkTheme.border[`hex${num}`] = array[1];
});


export { lightTheme, darkTheme };